<template>
    <div>
        <modal class="biz-release-appeal" :display="modalStatus.bizReleaseAppeal" @modalStatus="closeModal" >
            <h1>退租申訴</h1>
            <div class="biz-release-appeal-wrap">
                <div class="input-block">
                    <label class="button-font input-label">
                        <div class="title">
                            <span class="must-fill">*</span>
                            申訴事由
                        </div>
                        <span v-show="error.appealReason" class="error-with-title">{{error.appealReason}}</span>
                    </label>
                    <div class="input-arear">
                        <textarea class="appeal-reason" :class="{error: error.appealReason}" v-model="insertData.appealReason" placeholder="最多1000字"></textarea>
                    </div>
                </div>
                <div class="input-block">
                    <label class="button-font input-label">
                        <div class="title">
                            <span class="must-fill"></span>
                            檢附圖 ( 最多上傳五張)
                        </div>
                        <span v-show="error.appealImage" class="error-with-title">{{error.appealImage}}</span>
                    </label>
                    <div class="input-arear">
                        <div  v-if="insertData.appealImage.length" class="has-img">
                            <ul>
                                <li v-for="(item, index) in insertData.appealImage" :key="index">
                                    <div class="preview">
                                        <img  :src="item.blob" />
                                    </div>
                                    <img class="cancel" @click.prevent="$refs.upload.remove(item)" src="@/assets/img/icon/cancel_black.svg" alt="">
                                    <span v-if="error.appealImage">{{error.appealImage}}</span>
                                </li>
                                <li class="list-upload" v-show="insertData.appealImage.length < 5" :class="{'drop-active': $refs.upload && $refs.upload.dropActive}">
                                    <file-upload
                                    class="upload-btn"
                                    post-action="/upload/post"
                                    :size="1024 * 5"
                                    :maximum="5"
                                    :multiple="true"
                                    :drop="true"
                                    :drop-directory="true"
                                    v-model="insertData.appealImage"
                                    @input-file="inputFile"
                                    @input-filter="inputFilter"
                                    ref="upload">
                                        <img class="upload-icon" src="@/assets/img/icon/upload_biz.svg" alt="">
                                        <span class="upload-description">拖放檔案或點擊此區立即上傳</span>
                                        <span class="upload-drop-alarm">將圖片拖放到這裡</span>
                                    </file-upload>
                                </li>
                            </ul>
                        </div>
                        <div v-show="!insertData.appealImage.length" class="appeal-upload">
                            <file-upload
                            class="upload-btn"
                            post-action="/upload/post"
                            input-id="cover"
                            :size="1024 * 5"
                            :maximum="5"
                            :multiple="true"
                            v-model="insertData.appealImage"
                            @input-file="inputFile"
                            @input-filter="inputFilter"
                            ref="uploadCover">
                                <img class="upload-icon" src="@/assets/img/mb/icon/upload.svg" alt="">
                                上傳圖片
                            </file-upload>
                        </div>
                    </div>
                </div>
            </div>
            <div class="btn-group">
                <button class="default-button confirm" :disabled="isDisabled || isLoading" @click="setReleaseAppeal()">送出</button>
            </div>
        </modal>
    </div>
</template>
<script>
import Modal from '@/components/widge/Modal.vue';
import FileUpload from 'vue-upload-component';
import { mapGetters } from 'vuex'

import { 
    setReleaseAppeal
    } from "@/apis/company/leaseMgt.js"; 
const defaultParams = {
    contractSeq: null,
    appealReason: null,
    appealImage: []
}
export default {
    data () {
        return {
            componentKey: 0,
            insertData: JSON.parse(JSON.stringify(defaultParams)),
            error: {
                appealReason: null,
                appealImage: null,
            },
            isLoading: false
        }
    },
    props: {
        contractObj: null
    },
    destroyed(){
    },
    watch: {
        contractObj: {
            handler: function (val) {
                console.log(val.contractSeq)
                this.insertData.contractSeq = val.contractSeq
            },
            deep: true,
            immediate: true
        },
        'insertData.appealReason': {
            handler: function (val) {
                console.log(val.length)
                if(val.length > 1000){
                    this.error.appealReason = '字數需1000字以內'
                }else{
                    this.error.appealReason = null
                }
                
            },
        }
    },
    methods: {
        inputFile: function (newFile, oldFile) {
            if (newFile && oldFile && !newFile.active && oldFile.active) {
                // Get response data
                if (newFile.xhr) {
                //  Get the response status code
                // console.log('status', newFile.xhr.status)
                }
            }
        },
        inputFilter: function (newFile, oldFile, prevent) {
                console.log('response', newFile)
        
            if (newFile && !oldFile) {
                // Filter non-image file
                if (!/\.(jpeg|jpe|jpg|png)$/i.test(newFile.name)) {
                    this.alart.fail = true
                    this.msg.error = '請上傳JPG或PNG檔案'
                    return prevent()
                }

                if(newFile.size > (1024*1024*5)){
                    this.alart.fail = true
                    this.msg.error = '檔案最大限制5MB'
                    return prevent()
                }
            }
            // console.log(newFile)
            // Create a blob field
            newFile.blob = ''
            let URL = window.URL || window.webkitURL
            if (URL && URL.createObjectURL) {
                newFile.blob = URL.createObjectURL(newFile.file)
            }
        },
        setReleaseAppeal: function () {
            if(this.checkInput()){
                this.isLoading = true
                let formData = new FormData();
                formData.append('contractSeq', this.insertData.contractSeq);
                formData.append('appealReason', this.insertData.appealReason);
                for (let i = 0; i < this.insertData.appealImage.length; i++) {
                    const element = this.insertData.appealImage[i];
                    formData.append('appealImage', element.file);
                }
                setReleaseAppeal(formData)
                .then(res => {
                    console.log(res)
                    if( res.data.status == "SUCCESS" ){
                        this.$store.dispatch('setAlarmStatus', {status: true,title: '成功送出退租申訴',type: 'success',closeBtn: false})
                        this.$store.dispatch('getBizLeaseProcessMgtList')
                    }else{
                        this.$store.dispatch('setAlarmStatus', {status: true,title: res.data.errorMsg,type: 'error',closeBtn: false})
                    }
                    this.closeModal()
                    this.isLoading = false
                })
                .catch(err => {
                    console.log(err)
                    this.isLoading = false
                })
            }
        },
        checkInput: function () {
            if(
                // this.insertData.cid &&
                this.insertData.contractSeq &&
                this.insertData.appealReason &&
                this.insertData.appealImage &&
                // !this.error.cid &&
                !this.error.contractSeq &&
                !this.error.appealReason &&
                !this.error.appealImage 
            ){
                return true
            }else{
                return false
            }
        },
        closeModal: function () {
            this.$store.dispatch('setModalStatus', {state: false, type: 'bizReleaseAppeal'})
            this.insertData = JSON.parse(JSON.stringify(defaultParams))
            this.error.appealReason = null
            this.error.appealImage = null
        },
    },
    computed: {
        isDisabled() {
            if(
                this.insertData.contractSeq &&
                this.insertData.appealImage &&
                this.insertData.appealReason
            ){
                return false
            }else{
                return true
            }
        },
        ...mapGetters({
            modalStatus: 'GET_MODAL_STATUS',
        })
    },
    components: {
        Modal,
        FileUpload
    }
}
</script>
<style lang="scss">
    #modal.biz-release-appeal{
        .error{
            right: 0px;
            top: -24px;
            left: unset;
        }
        .modal-content{
            width: 756px;
            padding: 0 !important;
            .detail{
                >h1{
                    margin-top: 32px;
                    margin-bottom: 42px;
                }
                .biz-release-appeal-wrap{
                    width: 692px;
                    padding: 0 32px 0 32px;
                    .input-block{
                        margin-bottom: 24px;
                    }
                    .appeal-reason{
                        height: 216px;
                        padding: 12px 16px;
                    }
                    .appeal-upload{
                        position: relative;
                        width: 100%;
                        height: 150px;
                        border-radius: 4px;
                        border: dashed 1px #cacfcd;
                        background-color: #ffffff;
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        justify-content: center;
                        img{
                            margin-bottom: 8px;
                        }
                        .upload-btn{
                            width: 100%;
                            height: 100%;
                            display: flex;
                            flex-direction: column;
                            align-items: center;
                            justify-content: center;
                        }

                    }
                    .has-img{
                        ul{
                            display: flex;
                            flex-wrap: wrap;
                            li{
                                position: relative;
                                margin-right: 14px;
                                margin-bottom: 13px;
                                cursor: pointer;
                                .preview{
                                    width: 124px;
                                    height: 93px;
                                    display: flex;
                                    align-items: center;
                                    border-radius: 4px;
                                    overflow: hidden;
                                    >img{
                                        width: 100%;
                                    }
                                }
                                .cancel{
                                    position: absolute;
                                    cursor: pointer;
                                    top: -14px;
                                    right: -14px;
                                    width: 30px;
                                }
                                
                            }
                            li:nth-child(5n){
                                margin-right: 0px;
                            }
                            .list-upload{
                                width: 222px;
                                height: 93px;
                                border-radius: 4px;
                                border: dashed 1px #cacfcd;
                                background-color: #ffffff;
                                display: flex;
                                flex-direction: column;
                                align-items: center;
                                justify-content: center;
                                img{
                                    width: 27px;
                                    margin-bottom: 4px;
                                }
                                .upload-btn{
                                    width: 100%;
                                    height: 100%;
                                    display: flex;
                                    flex-direction: column;
                                    align-items: center;
                                    justify-content: center;
                                }
                                .upload-drop-alarm{
                                    display: none;
                                }
                            }
                            .list-upload.drop-active{
                                border: solid 1px #ff9275;
                                background-color: #fff4f1;
                                .upload-icon,
                                .upload-description,
                                .upload-warm{
                                    display: none;
                                }
                                .upload-drop-alarm{
                                    display: block;
                                    font-weight: 500;
                                    color: #ff9275;
                                }
                                
                            }
                        }
                    }
                }
            }
            
            .btn-group{
                display: flex;
                justify-content: center;
                align-items: center;
                width: 100%;
                height: 84px;
                box-shadow: 0 4px 20px 0 rgba(37, 38, 94, 0.1);
                border-radius:  0 0 20px 20px;
                margin: 0 auto;
                button{
                    width: 384px;
                    height: 44px;
                }
            }
        }
    }
    #modal.no-close{
        .cancle{
            display: none;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/bussiness/mgtCategory/leaseMgt/leaseProcess/releaseAppeal.vue